import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import useSWR from 'swr';
import Anasayfa from './Anasayfa';
import SiparisGirisFormu from './SiparisGirisFormu';
import SiparisListesi from './SiparisListesi';
import TeklifListesi from './TeklifListesi';
import DefterDokumu from './DefterDokumu';
import UrunYonetimi from './UrunYonetimi';
import MusterilerListesi from './MusterilerListesi';
import EftTakibi from './EftTakibi';
import GonderiTakibi from './GonderiTakibi';
import KullaniciYonetimi from './KullaniciYonetimi'; // <-- YENİ IMPORT
import Login from './Login';
import FinansalDetaylar from './FinansalDetaylar';
import HaberAkisi from './HaberAkisi';
import HavaDurumu from './HavaDurumu';
import logo from './assets/images/syplogo.png';
import TedarikListesi from './TedarikListesi';
import CokluSiparis from './CokluSiparis';
import BekleyenKargolar from './BekleyenKargolar';
import TeslimatTalepleri from './TeslimatTalepleri';
import ParasutAuthorize from './ParasutAuthorize'; // <-- PARAŞÜT IMPORT
import SilinmislerListesi from './SilinmislerListesi';
import Whatsapp from './Whatsapp';

function ProtectedRoute({ user, children }) {
    if (!user) {
        // Eğer kullanıcı bilgisi yoksa, login sayfasına yönlendir.
        return <Navigate to="/login" replace />;
    }
    // Kullanıcı varsa, istenen sayfayı göster.
    return children;
}

function AdminRoute({ user, children }) {
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    if (user.rol !== 'admin') {
        // Admin olmayan kullanıcıları anasayfaya yönlendir
        return <Navigate to="/" replace />;
    }
    return children;
}

function RoleRoute({ user, allowedRoles, children }) {
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    if (!allowedRoles.includes(user.rol)) {
        // Yetkisiz kullanıcıları anasayfaya yönlendir
        return <Navigate to="/" replace />;
    }
    return children;
}

function AppWrapper() {
    const navigate = useNavigate(); // navigate fonksiyonunu burada tanımlıyoruz
    const [user, setUser] = useState(() => {
        try {
            const savedUser = localStorage.getItem('user');
            return savedUser ? JSON.parse(savedUser) : null;
        } catch (error) { return null; }
    });

    const handleLoginSuccess = (data) => {
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        setUser(data.user);
        // --- EN ÖNEMLİ DEĞİŞİKLİK BURADA ---
        // State güncellendikten hemen sonra anasayfaya yönlendiriyoruz.
        navigate('/');
    };

    const handleLogout = () => {
        setUser(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login'); // Çıkış yapınca da login'e yönlendir
    };
    
    return (
        <Routes>
            <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
            
            <Route path="/*" element={
                <ProtectedRoute user={user}>
                    <MainLayout user={user} onLogout={handleLogout} />
                </ProtectedRoute>
            }/>
        </Routes>
    );
}

// --- ANA UYGULAMA BİLEŞENİ ---
function App() {
    const [user, setUser] = useState(() => {
        try {
            const savedUser = localStorage.getItem('user');
            return savedUser ? JSON.parse(savedUser) : null;
        } catch (error) {
            return null;
        }
    });

    const handleLoginSuccess = (userData) => {
        localStorage.setItem('user', JSON.stringify(userData.user));
        localStorage.setItem('token', userData.token);
        setUser(userData.user);
    };

    const handleLogout = () => {
        setUser(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    };
    
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" 
                element={!user ? <Login onLoginSuccess={handleLoginSuccess} /> : <Navigate to="/" replace />} />
                <Route path="/*" element={
                    <ProtectedRoute user={user}>
                        {/* --- EKSİK OLAN ROTALAR BURAYA EKLENDİ --- */}
                        <Routes>
                            <Route path="/" element={<MainLayout user={user} onLogout={handleLogout} />}>
                                <Route index element={<Anasayfa />} />
                                <Route path="siparisler" element={<SiparisListesi />} />
                                <Route path="siparis-girisi" element={<SiparisGirisFormu />} />
                                <Route path="siparis/duzenle/:siparisId" element={<SiparisGirisFormu />} />
                                <Route path="defter-dokumu" element={<DefterDokumu />} />
                                <Route path="urun-yonetimi" element={<UrunYonetimi />} />
                                <Route path="musteriler" element={<RoleRoute user={user} allowedRoles={['admin', 'operator', 'satis_operatoru']}><MusterilerListesi /></RoleRoute>} />
                                <Route path="eft-takibi" element={<RoleRoute user={user} allowedRoles={['admin', 'operator', 'satis_operatoru']}><EftTakibi /></RoleRoute>} />
                                <Route path="finansal-detaylar" element={<RoleRoute user={user} allowedRoles={['admin', 'operator']}><FinansalDetaylar /></RoleRoute>} />
                                <Route path="kullanici-yonetimi" element={<AdminRoute user={user}><KullaniciYonetimi /></AdminRoute>} />
                                <Route path="tedarik-listesi" element={<TedarikListesi />} />
                                <Route path="coklu-siparis" element={<CokluSiparis />} />
                                <Route path="teklifler" element={<TeklifListesi />} />
                                <Route path="bekleyen-kargolar" element={<RoleRoute user={user} allowedRoles={['admin', 'operator', 'satis_operatoru', 'depo_operatoru']}><BekleyenKargolar /></RoleRoute>} />
                                {/* Takip Edilenler, Gönderi Takibi'nin "Takip Edilenler" filtresine taşındı */}
                                <Route path="takip-edilenler" element={<Navigate to="/gonderi-takibi" replace />} />
                                <Route path="talepler" element={<TeslimatTalepleri />} />
                                <Route path="gonderi-takibi"element={<RoleRoute user={user} allowedRoles={['admin', 'operator', 'satis_operatoru']}><GonderiTakibi /></RoleRoute>} />
                                <Route path="parasut/authorize" element={<ParasutAuthorize />} />
                                <Route path="test-whatsapp" element={<Whatsapp />} />
                                <Route path="silinenler" element={<RoleRoute user={user} allowedRoles={['admin', 'operator', 'satis_operatoru']}><SilinmislerListesi /></RoleRoute>} />
                            </Route>
                        </Routes>
                    </ProtectedRoute>
                }/>
            </Routes>
        </BrowserRouter>
    );
}

function MainLayout({ user, onLogout }) {
  const globalMesajSayisiRef = useRef(0);
  
  // --- GLOBAL NOT BİLDİRİMİ İÇİN ---
  const [notToastlar, setNotToastlar] = useState([]); // [{ id, icerik, ekleyen, renk }]
  const sonGorülenNotIdRef = useRef(-1); // -1: henüz initialize edilmedi
  const toastSayaciRef = useRef(0);

  const NOT_RENK_PALETI = [
    { bg: '#e8f4fd', border: '#3783c2', text: '#1a5276' },
    { bg: '#eafaf1', border: '#219852', text: '#1a6b38' },
    { bg: '#fef9e7', border: '#f4bf4a', text: '#7d6608' },
    { bg: '#fdf2f8', border: '#a32e68', text: '#6c1d45' },
    { bg: '#f4ecf7', border: '#6761a8', text: '#4a235a' },
    { bg: '#fef5ec', border: '#F3994A', text: '#784212' },
    { bg: '#e8f8f5', border: '#17bebb', text: '#0e6655' },
    { bg: '#fdedec', border: '#dc3545', text: '#922b21' },
  ];

  const getNotRenk = (ekleyen) => {
    if (!ekleyen) return { bg: '#f8f9fa', border: '#e8e8e8', text: '#555' };
    let hash = 0;
    for (let i = 0; i < ekleyen.length; i++) hash += ekleyen.charCodeAt(i);
    return NOT_RENK_PALETI[hash % NOT_RENK_PALETI.length];
  };

  const notToastGoster = (icerik, ekleyen) => {
    const renk = getNotRenk(ekleyen);
    const uid = toastSayaciRef.current++;
    setNotToastlar(prev => [...prev, { uid, icerik, ekleyen, renk }]);
  };

  const notToastKapat = (uid) => {
    setNotToastlar(prev => prev.filter(t => t.uid !== uid));
  };

  // Genel fetcher
  const fetcher = url => {
    const token = localStorage.getItem('token');
    return fetch(url, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(res => {
        if (!res.ok) {
            throw new Error('Yetkilendirme hatası veya sunucuya ulaşılamadı.');
        }
        return res.json();
    });
  };
  
  const { data: globalMesajlar } = useSWR(
    user ? '/api/grup-mesajlari' : null,
    fetcher,
    { refreshInterval: 5000 }
  );
  
  // Global mesaj bildirimi
  useEffect(() => {
    if (!user) return;
    
    // İlk yüklemede mevcut mesaj sayısını localStorage'dan al
    if (globalMesajlar && globalMesajlar.length > 0) {
      const kaydedilmisSayi = localStorage.getItem('global_son_mesaj_sayisi');
      if (kaydedilmisSayi) {
        globalMesajSayisiRef.current = parseInt(kaydedilmisSayi, 10);
      } else {
        // İlk kez yükleniyorsa, mevcut mesaj sayısını kaydet
        globalMesajSayisiRef.current = globalMesajlar.length;
        localStorage.setItem('global_son_mesaj_sayisi', globalMesajlar.length.toString());
        return; // İlk yüklemede ses çalmasın
      }
    }
    
    // Yeni mesaj kontrolü
    if (globalMesajlar && globalMesajlar.length > globalMesajSayisiRef.current) {
      const yeniMesajlar = globalMesajlar.slice(globalMesajSayisiRef.current);
      
      yeniMesajlar.forEach(yeniMesaj => {
        if (yeniMesaj.gonderen_id !== user.id) {
          // Ses çal
          const audio = new Audio('/notification.mp3');
          audio.play().catch(e => console.error("Ses çalınamadı:", e));
          
          // Browser bildirimi (tab aktif değilse)
          if ('Notification' in window && Notification.permission === 'granted' && document.hidden) {
            try {
              const notification = new Notification('Yeni Grup Mesajı', {
                body: `${yeniMesaj.gonderen_adi}: ${yeniMesaj.icerik.length > 50 ? yeniMesaj.icerik.substring(0, 50) + '...' : yeniMesaj.icerik}`,
                icon: '/favicon.ico',
                tag: 'grup-mesaji-global',
                requireInteraction: false
              });
              
              setTimeout(() => notification.close(), 5000);
              
              notification.onclick = () => {
                window.focus();
                notification.close();
              };
            } catch (error) {
              console.error("Global bildirim gösterilemedi:", error);
            }
          }
        }
      });
      
      // Mesaj sayısını güncelle
      globalMesajSayisiRef.current = globalMesajlar.length;
      localStorage.setItem('global_son_mesaj_sayisi', globalMesajlar.length.toString());
    }
  }, [globalMesajlar, user]);
  
  // Bildirim izni iste
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  // --- GLOBAL NOT BİLDİRİMİ POLLING ---
  const { data: globalNotlar } = useSWR(
    user ? '/api/sabit-notlar' : null,
    fetcher,
    { refreshInterval: 5000 }
  );

  useEffect(() => {
    if (!globalNotlar || globalNotlar.length === 0) return;

    const maxId = Math.max(...globalNotlar.map(n => n.id));

    // İlk yükleme: sadece referans ID'yi kaydet, toast gösterme
    if (sonGorülenNotIdRef.current === -1) {
      sonGorülenNotIdRef.current = maxId;
      return;
    }

    // Yeni not var mı?
    if (maxId > sonGorülenNotIdRef.current) {
      const yeniNotlar = globalNotlar.filter(n => n.id > sonGorülenNotIdRef.current);
      // En son eklenen notu göster
      const son = yeniNotlar[yeniNotlar.length - 1];
      notToastGoster(son.icerik, son.ekleyen);
      sonGorülenNotIdRef.current = maxId;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalNotlar]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8f8f8' }}>
      {/* SOL NAVİGASYON MENÜSÜ */}
      <nav style={{
            width: '220px',
            background: '#272935',
            color: 'white',
            flexShrink: 0, // Sayfa küçülse bile menünün daralmamasını sağlar
            position: 'fixed',
            left: 0,
            top: 0,
            height: '100vh',
            overflowY: 'auto',
            zIndex: 1000
        }}>
            <div style={{ padding: '20px 20px 15px 20px', textAlign: 'center', borderBottom: '1px solid #ffffff20' }}>
                    <img src={logo} alt="SYP Logo" style={{ width: '130px', marginBottom: '0px' }} />
                </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: '10px 0' }}>
                <li>
                  <NavLink 
                      to="/" 
                      end
                      style={({ isActive }) => ({
                          display: 'block', padding: '12px 20px', color: 'white',
                          textDecoration: 'none', fontSize: 14,
                          background: isActive ? '#EA4E25' : 'transparent',
                          fontWeight: isActive ? 'bold' : 'normal'
                      })}
                  >
                      ANASAYFA
                  </NavLink>
                </li> 
                <li>
                    <NavLink 
                        to="/siparisler" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        SİPARİŞ LİSTESİ
                    </NavLink>
                </li>
                <li>
                    <NavLink 
                        to="/defter-dokumu" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        DEFTER DÖKÜMÜ
                    </NavLink>
                </li>
                {['admin', 'operator', 'satis_operatoru'].includes(user.rol) && (
                    <li>
                        <NavLink 
                            to="/eft-takibi" 
                            style={({ isActive }) => ({
                                display: 'block', padding: '12px 20px', color: 'white',
                                textDecoration: 'none', fontSize: 14,
                                background: isActive ? '#EA4E25' : 'transparent',
                                fontWeight: isActive ? 'bold' : 'normal'
                            })}
                        >
                            ÖDEME TAKİBİ
                        </NavLink>
                    </li>
                )}
                <li>
                    <NavLink
                        to="/talepler"
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        TALİMATLAR
                    </NavLink>
                </li>
                <li>
                    <NavLink 
                        to="/urun-yonetimi" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        ÜRÜN YÖNETİMİ
                    </NavLink>
                </li>
                <li>
                    <NavLink 
                        to="/tedarik-listesi" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        TEDARİK LİSTELERİ
                    </NavLink>
                </li>
                <li>
                    <NavLink 
                        to="/coklu-siparis" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        ÇOKLU SİPARİŞ
                    </NavLink>
                </li>
                <li>
                    <NavLink 
                        to="/teklifler" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        TEKLİFLER
                    </NavLink>
                </li>
                {['admin', 'operator', 'satis_operatoru'].includes(user.rol) && (
                    <li>
                        <NavLink 
                            to="/musteriler" 
                            style={({ isActive }) => ({
                                display: 'block', padding: '12px 20px', color: 'white',
                                textDecoration: 'none', fontSize: 14,
                                background: isActive ? '#EA4E25' : 'transparent',
                                fontWeight: isActive ? 'bold' : 'normal'
                            })}
                        >
                            MÜŞTERİLER
                        </NavLink>
                    </li>
                )}
                {['admin', 'operator'].includes(user.rol) && (
                    <li>
                        <NavLink 
                            to="/finansal-detaylar" 
                            style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                        >
                            FİNANSAL DETAYLAR
                        </NavLink>
                    </li>
                )}
                <li>
                    <NavLink 
                        to="/bekleyen-kargolar" 
                        style={({ isActive }) => ({
                            display: 'block', padding: '12px 20px', color: 'white',
                            textDecoration: 'none', fontSize: 14,
                            background: isActive ? '#EA4E25' : 'transparent',
                            fontWeight: isActive ? 'bold' : 'normal'
                        })}
                    >
                        BEKLEYEN PAKETLER
                    </NavLink>
                </li>

                {['admin', 'operator', 'satis_operatoru'].includes(user.rol) && (
                    <li>
                        <NavLink 
                            to="/gonderi-takibi" 
                            style={({ isActive }) => ({
                                display: 'block', padding: '12px 20px', color: 'white',
                                textDecoration: 'none', fontSize: 14,
                                background: isActive ? '#EA4E25' : 'transparent',
                                fontWeight: isActive ? 'bold' : 'normal'
                            })}
                        >
                            GÖNDERİ TAKİBİ
                        </NavLink>
                    </li>
                )}

                {['admin', 'operator', 'satis_operatoru'].includes(user.rol) && (
                    <li>
                        <NavLink 
                            to="/silinenler" 
                            style={({ isActive }) => ({
                                display: 'block', padding: '12px 20px', color: 'white',
                                textDecoration: 'none', fontSize: 14,
                                background: isActive ? '#EA4E25' : 'transparent',
                                fontWeight: isActive ? 'bold' : 'normal'
                            })}
                        >
                            ÇÖP KUTUSU
                        </NavLink>
                    </li>
                )}
                {user.rol === 'admin' && (
                    <li>
                        <NavLink 
                            to="/kullanici-yonetimi" 
                            style={({ isActive }) => ({
                                display: 'block', padding: '12px 20px', color: 'white',
                                textDecoration: 'none', fontSize: 14,
                                background: isActive ? '#EA4E25' : 'transparent',
                                fontWeight: isActive ? 'bold' : 'normal'
                            })}
                        >
                            KULLANICILAR
                        </NavLink>
                    </li>
                )}

            </ul>
        </nav>
        
      {/* SAĞ İÇERİK ALANI */}
        <main style={{ flex: 1, overflowY: 'auto', marginLeft: '220px' }}>
                <header style={{  
                    padding: '30px 25px', 
                    background: 'linear-gradient(90deg, #3884C2 0%, #255380 100%)', 
                    color: 'white', 
                    borderRadius: '0px', 
                    marginBottom: '0px', 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    left: '220px',
                    zIndex: 999,
                    boxSizing: 'border-box',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                    <HaberAkisi />
                    <HavaDurumu />
                    <div className="user-menu">
                        <span>{user?.gorunen_ad || 'Kullanıcı'} ▼</span>
                        <div className="dropdown-content">
                            <button onClick={onLogout}>Çıkış Yap</button>
                        </div>
                    </div>
                </header>
                {/* Header altında zemin rengi geçiş alanı */}
                <div style={{
                    position: 'fixed',
                    top: '80px', // Header yüksekliği (30px padding * 2 + yaklaşık içerik yüksekliği)
                    right: 0,
                    left: '220px',
                    height: '8px',
                    background: '#f0f0f0',
                    zIndex: 998
                }}></div>
                {/* Bu Outlet, MainLayout'un içindeki iç içe rotaların render edileceği yerdir */}
                <div style={{ 
                    paddingTop: '108px', 
                    padding: '108px 20px 20px 20px',
                    position: 'relative',
                    zIndex: 1,
                    marginTop: '-5px'
                }}>
                    <Outlet  context={{ user }} />
                </div>
            </main>

        {/* GLOBAL NOT TOAST BİLDİRİMLERİ */}
        <div style={{
            position: 'fixed',
            bottom: '28px',
            right: '28px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            zIndex: 10000,
            alignItems: 'flex-end',
        }}>
            {notToastlar.map((toast) => (
                <div key={toast.uid} style={{
                    backgroundColor: toast.renk.bg,
                    border: `1px solid ${toast.renk.border}`,
                    borderLeft: `4px solid ${toast.renk.border}`,
                    borderRadius: '10px',
                    padding: '12px 16px',
                    width: '280px',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.13)',
                    fontFamily: 'Poppins, sans-serif',
                    animation: 'notToastGiris 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                }}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px'}}>
                        <span style={{fontSize: '13px', color: toast.renk.border, fontWeight: '700'}}>✓ Yeni Not</span>
                        <span
                            onClick={() => notToastKapat(toast.uid)}
                            style={{fontSize: '13px', color: '#aaa', lineHeight: 1, cursor: 'pointer', padding: '0 2px'}}
                        >✕</span>
                    </div>
                    <span style={{fontSize: '12px', color: '#2c3e50', wordBreak: 'break-word'}}>{toast.icerik}</span>
                    {toast.ekleyen && (
                        <span style={{fontSize: '11px', color: toast.renk.text, fontWeight: '600', opacity: 0.85}}>{toast.ekleyen}</span>
                    )}
                </div>
            ))}
        </div>
        <style>{`@keyframes notToastGiris { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
}




export default App;